import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleNote } from '../../../state/slices/currentSale/currentSaleSlice'

export const SaleNoteSection: FunctionComponent = () => {
  const note = useAppSelector(selectSaleNote)

  return (
    <section className="sale-summary-section sale-summary-section--note">
      <div className="wr-honour-line-breaks">
        <T
          _str="Note: {note}"
          note={note}
          _context="Sale note section in receipt preview"
        />
      </div>
    </section>
  )
}
